import {
  BROADCAST_SET_DIRECTOR_REQUEST,
  BROADCAST_CLEAR_DIRECTOR_REQUEST,
  BROADCAST_SET_DIRECTOR_REQUEST_ASYNC
} from 'actions/Types';

/** Empty Request */
const initialState = [];

function directorRequest(state = initialState, action) {
  /** For legacy and waiting support */
  if (
    [
      BROADCAST_SET_DIRECTOR_REQUEST,
      `${BROADCAST_SET_DIRECTOR_REQUEST_ASYNC}_SUCCESS`
    ].includes(action.type)
  ) {
    const { payload } = action;

    return [...state, payload];
  }

  if (action.type === BROADCAST_CLEAR_DIRECTOR_REQUEST) {
    const { payload } = action;
    return state.filter(
      req =>
        req.requestType !== payload.requestType || req._id !== payload.requestId
    );
  }

  return state;
}

export default directorRequest;
